import React from "react"

import dataLayerHelper from "../../helpers/datalayer.helper"

import {
  CardTitle,
  CardContent,
  Excerpt,
  CareerPathCardContainer,
  MilestonesContainer,
  PathButtonLink,
  PathImage,
  TickIcon,
  ButtonContainer,
} from "./career-path-card.styles"

const CareerPathCard = ({ path }) => {
  const { pinnedCtaImage, name, slug, excerpt, timelineContent } = path
  const pathStats = {
    milestones: timelineContent.length,
    courses: 0,
  }

  timelineContent.forEach((content) => {
    if (content.type.toString() === "Course") pathStats.courses++
  })

  const milestoneLabel = pathStats.milestones > 1 ? " milestones" : " milestone"
  const courseLabel = pathStats.courses > 1 ? " courses" : " course"

  return (
    <CareerPathCardContainer>
      <a
        href={`/career-paths/${slug}`}
        tabIndex="-1"
        onClick={() =>
          dataLayerHelper({
            event: "careerPathCardImageClick",
            label: name,
          })
        }
      >
        <PathImage style={{ display: "block" }} image={pinnedCtaImage.gatsbyImageData} alt="career path" />
      </a>
      <CardContent>
        <CardTitle
          href={`/career-paths/${slug}`}
          tabIndex="-1"
          onClick={() =>
            dataLayerHelper({
              event: "careerPathCardTitleClick",
            })
          }
        >
          {name}
        </CardTitle>
        <MilestonesContainer>
          <TickIcon />
          {pathStats.milestones}
          {milestoneLabel} <span>•</span> {pathStats.courses}
          {courseLabel}
        </MilestonesContainer>

        <Excerpt>{excerpt}</Excerpt>
      </CardContent>
      <ButtonContainer>
        <PathButtonLink
          small
          secondary
          square
          ghost
          url={`/career-paths/${slug}`}
          internal
          onClick={() =>
            dataLayerHelper({
              event: "careerPathCardButtonClick",
              label: name,
            })
          }
        >
          Explore Career Path
        </PathButtonLink>
      </ButtonContainer>
    </CareerPathCardContainer>
  )
}

export default CareerPathCard
